import React from 'react';
import LegalLayout from '../components/LegalLayout';

export default function PrivacyPage() {
  return (
    <LegalLayout title="Privacy Policy" lastUpdated="June 25, 2026" testId="privacy-page">
      <p>This Privacy Policy explains how <strong>Delphi AI</strong> collects, uses, and protects your information. By using the Service, you consent to the practices described here.</p>

      <h2>1. Information we collect</h2>
      <h3>You provide:</h3>
      <ul>
        <li>Account info: name, email, hashed password.</li>
        <li>Billing info: handled by Stripe; we receive the last 4 digits, card brand, and billing country only.</li>
        <li>Content you upload: portraits, reference media, prompts, voice samples.</li>
      </ul>
      <h3>Collected automatically:</h3>
      <ul>
        <li>Device, browser, IP (hashed), and usage telemetry (page views, generation events).</li>
        <li>Cookies and similar technologies (see our Cookie Policy).</li>
      </ul>

      <h2>2. How we use your data</h2>
      <ul>
        <li>To operate, secure, and improve the Service.</li>
        <li>To dispatch your content to partner AI models (Sora 2, Nano Banana, HeyGen, ElevenLabs, Suno) so they can render it.</li>
        <li>To process payments via Stripe.</li>
        <li>To send transactional email (welcome, trial warnings, receipts, content-ready notifications).</li>
        <li>To detect fraud, abuse, and violations of our Terms.</li>
      </ul>

      <h2>3. AI model partners</h2>
      <p>Generated content is processed through third-party AI APIs. Each partner has its own privacy posture. Inputs you submit may transit through their infrastructure. We never sell your content. We work only with partners who contractually commit to not training on our customers&apos; inputs by default.</p>

      <h2>4. Data sharing</h2>
      <p>We do <strong>not</strong> sell your personal information. We share data only with:</p>
      <ul>
        <li>Service providers (hosting, email delivery, payment processing) under data-processing agreements.</li>
        <li>AI model partners required to fulfill your generation request.</li>
        <li>Law enforcement when legally compelled.</li>
      </ul>

      <h2>5. Retention</h2>
      <p>We retain account data while your account is active. Generated content is retained per your tier&apos;s storage policy. You may request deletion at any time by emailing <strong>support@delphiai.ca</strong>; deletion will be completed within 30 days.</p>

      <h2>6. Your rights</h2>
      <p>Depending on your jurisdiction (including GDPR, CCPA), you may have rights to access, correct, export, or delete your data. Send requests to <strong>support@delphiai.ca</strong>.</p>

      <h2>7. Security</h2>
      <p>We use industry-standard practices: encryption in transit (TLS), encryption at rest, hashed passwords (bcrypt), and least-privilege access controls. No system is perfectly secure; report concerns to <strong>security@delphiai.ca</strong>.</p>

      <h2>8. Children</h2>
      <p>The Service is not intended for users under 18. We do not knowingly collect data from minors.</p>

      <h2>9. International transfers</h2>
      <p>Data may be processed in the United States, Canada, the EU, and partner-provider regions. We rely on Standard Contractual Clauses where required.</p>

      <h2>10. Updates</h2>
      <p>Material changes will be communicated by email or in-product. The &quot;last updated&quot; date above reflects the current version.</p>

      <h2>11. Contact</h2>
      <p>Privacy questions: <strong>privacy@delphiai.ca</strong>.</p>
    </LegalLayout>
  );
}
